import { render, staticRenderFns } from "./IntercomManagement.vue?vue&type=template&id=2624795e&scoped=true"
import script from "./IntercomManagement.vue?vue&type=script&lang=js"
export * from "./IntercomManagement.vue?vue&type=script&lang=js"
import style0 from "./IntercomManagement.vue?vue&type=style&index=0&id=2624795e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2624795e",
  null
  
)

export default component.exports